export const options = {
  colors: ['#FFCE75', '#F06F66', '#3d9ae2', '#875692', '#F1F1F1', '#666666', '#fec601'],
  credits: {
    enabled: false
  }
};
